<!-- 订单管理 -->
<template>
  <div class="diseaseList">
    <!-- 顶部操作栏：筛选 + 新增，与表格拼接成整块白卡 -->
    <div class="action-bar">
      <div class="action-left">
        <div class="search-group">
          <el-input
            class="search-input"
            v-model="listQuery.phone"
            placeholder="搜索手机号"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
          <el-button class="btn-search" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </div>
        <el-button
          class="btn-add"
          type="primary"
          @click="handleAdd"
          >新增订单</el-button
        >
      </div>
      <div class="action-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 条订单
      </div>
    </div>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="status" slot-scope="{ row }">
          <span class="status-chip" :class="'status-' + row.status">{{
            statusText(row.status)
          }}</span>
        </template>
        <template slot="openid" slot-scope="{ row }">
          <el-tooltip
            :content="row.openid"
            placement="top"
            :disabled="!row.openid"
          >
            <span class="cell-text">{{ row.openid }}</span>
          </el-tooltip>
        </template>
        <template slot="money" slot-scope="{ row }">
          <span class="money-text">¥{{ formatMoney(row.money) }}</span>
        </template>
        <template slot="msg" slot-scope="{ row }">
          <el-tooltip :content="row.msg" placement="top" :disabled="!row.msg">
            <span class="cell-text">{{ row.msg || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" class="op-edit" @click="handleEdit(row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              class="op-delete"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 右侧滑出抽屉表单 -->
    <el-drawer
      :title="dialogName"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="480px"
      :wrapper-closable="false"
      custom-class="store-drawer"
    >
      <div class="drawer-body">
        <!-- 档案头：图标 + 金额/状态 -->
        <div class="drawer-profile">
          <div class="profile-avatar"><i class="el-icon-s-order"></i></div>
          <div class="profile-info">
            <div class="profile-name">¥{{ formatMoney(dialogForm.money) }}</div>
            <div class="profile-phone">
              {{ statusText(dialogForm.status) }} ·
              {{ dialogForm.phone || "暂未填写" }}
            </div>
          </div>
        </div>

        <!-- 订单资料 -->
        <div class="drawer-section">
          <div class="section-title">订单资料</div>
          <el-form ref="form" :model="dialogForm" class="store-form">
            <div class="field-row">
              <span class="row-label">订单状态</span>
              <el-select
                v-model="dialogForm.status"
                placeholder="请选择"
                clearable
                class="full-select"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="field-row">
              <span class="row-label">openid</span>
              <el-input
                v-model="dialogForm.openid"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
            <div class="field-row">
              <span class="row-label">手机号</span>
              <el-input
                v-model="dialogForm.phone"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
            <div class="field-row">
              <span class="row-label">金额</span>
              <el-input
                v-model="dialogForm.money"
                placeholder="暂未填写"
                clearable
              ></el-input>
            </div>
          </el-form>

          <!-- 订单描述：标签在上 -->
          <div class="field-block">
            <div class="block-label">订单描述</div>
            <el-input
              class="desc-input"
              type="textarea"
              :rows="3"
              v-model="dialogForm.msg"
              placeholder="暂未填写"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-cancel" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button class="btn-confirm" type="primary" @click="save"
          >确 定</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import {
  addOrder,
  updateOrder,
  selectOrder,
  deleteOrder,
} from "@/services/mall/orderSystem";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
    // directives: {
  //   waves,
  // },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        /* 手机号搜索 */
        phone: "",
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      roleList: [
        { id: 0, name: "待处理" },
        { id: 1, name: "已处理" },
      ],
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
  },
  watch: {},
  methods: {
    /* 状态文案 */
    statusText(status) {
      if (status === 0 || status === "0") return "待处理";
      if (status === 1 || status === "1") return "已处理";
      return "——";
    },
    /* 手机号搜索 */
    handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    /* 金额格式化：保留两位小数 */
    formatMoney(val) {
      if (val === null || val === undefined || val === "") return "0.00";
      const n = Number(val);
      return isNaN(n) ? val : n.toFixed(2);
    },
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectOrder(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      console.log("listQuery", listQuery);
      this.listQuery = listQuery;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建订单";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "编辑订单";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      if (this.dialogName === "创建订单") {
        addOrder(this.dialogForm).then((res) => {
          console.log("创建订单", res);
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑订单") {
        updateOrder(this.dialogForm).then((res) => {
          console.log("编辑订单", res);
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
   
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
       
          deleteOrder({ id: row.id }).then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
    
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 顶部操作栏：白卡上半部，与表格拼接 */
.action-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .action-left {
    display: flex;
    align-items: center;
  }
  /* 输入框与搜索按钮拼接成一体，弱化次要操作 */
  .search-group {
    display: flex;
    align-items: center;

    /deep/ .search-input .el-input__inner {
      height: 32px;
      line-height: 32px;
      border-radius: 6px 0 0 6px;
    }
    .btn-search {
      height: 32px;
      margin-left: -1px;
      padding: 0 16px;
      font-size: 14px;
      color: #3d8dfc;
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 0 6px 6px 0;
      transition: all 0.2s;

      &:hover {
        color: #2f7be0;
        background: #f3f8ff;
        border-color: #3d8dfc;
        position: relative;
        z-index: 1;
      }
    }
  }
  .search-input {
    width: 220px;
  }
  .btn-add {
    height: 32px;
    margin-left: 12px;
    transition: all 0.2s;
    padding: 0 16px;
    font-size: 14px;
    background: #3d8dfc;
    border-color: #3d8dfc;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
      transform: translateY(-1px);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
      transform: translateY(0);
    }
  }

  /* 右侧统计信息，平衡一行视觉重心 */
  .action-meta {
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}

/* 表格区：白卡下半部 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }

  /* 单元格文本：单行省略，悬浮可看全文 */
  .cell-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}

/* 订单状态：浅色底小标签 */
.status-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;

  &.status-0 {
    background: #fdf3e1;
    color: #e6a23c;
  }
  &.status-1 {
    background: #e8f8ee;
    color: #00b42a;
  }
}

/* 金额：品牌色强调 */
.money-text {
  font-size: 14px;
  font-weight: 600;
  color: #f53f3f;
}

/* 操作列：编辑蓝实心 / 删除红字 */
.operation {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-button {
    margin: 0;
    padding: 0 12px;
    height: 24px;
    line-height: 1;
    font-size: 13px;
    border: 1px solid transparent;
    background: transparent;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease, background 0.15s ease,
      border-color 0.15s ease;
  }
  .op-edit {
    color: #fff;
    border-color: #3d8dfc;
    background: #3d8dfc;
    border-radius: 6px;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
    }
  }
  .op-delete {
    color: #f53f3f;
    border-left: 1px solid #e5e6eb;
    margin-left: 6px;
    padding-left: 16px;

    &:hover {
      color: #ff7875;
    }
  }
}

/* 右侧滑出抽屉 */
/deep/ .el-drawer__body {
  position: relative;
  padding: 0 0 64px;
}
/deep/ .store-drawer .el-drawer__header {
  padding: 16px 20px;
  margin-bottom: 0;
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
}
/deep/ .store-drawer .el-drawer__close-btn {
  color: #86909c;
}

.drawer-body {
  height: 100%;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 0 20px;
}

/* 档案头：图标 + 金额/状态 */
.drawer-profile {
  display: flex;
  align-items: center;
  padding-bottom: 16px;

  .profile-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #e5e6eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-right: 12px;
    flex-shrink: 0;
  }
  .profile-name {
    font-size: 16px;
    font-weight: 600;
    color: #1d2129;
    line-height: 22px;
  }
  .profile-phone {
    font-size: 13px;
    color: #86909c;
    line-height: 18px;
    margin-top: 2px;
  }
}

/* 分区标题：加粗 + 细分隔线 */
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f1f3;
  margin-bottom: 16px;
}

/* 表单行：标签在左 + 浅灰圆角输入框 */
.row-label {
  width: 70px;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
}
.field-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  .el-input,
  .el-select {
    flex: 1;
  }
}
.store-form /deep/ .el-input__inner {
  background: #f2f3f5;
  border: none;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  color: #1d2129;
  font-size: 14px;

  &::placeholder {
    color: #a9aeb8;
  }
}

/* 订单描述：标签在上 */
.field-block {
  margin-top: 4px;

  .block-label {
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
    margin-bottom: 8px;
  }
}
.desc-input /deep/ .el-textarea__inner {
  background: #f2f3f5;
  border: none;
  border-radius: 8px;
  padding: 12px 14px;
  color: #1d2129;
  font-size: 14px;
  line-height: 20px;

  &::placeholder {
    color: #a9aeb8;
  }
}

/* 底部固定操作栏：方圆按钮 */
.drawer-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 12px 20px;
  border-top: 1px solid #f0f1f3;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .btn-cancel,
  .btn-confirm {
    height: 36px;
    min-width: 104px;
    border-radius: 6px;
    font-size: 14px;
    padding: 0;
    transition: all 0.15s ease;
  }
  .btn-cancel {
    background: #fff;
    border: 1px solid #dcdee3;
    color: #4e5969;

    &:hover {
      color: #1d2129;
      border-color: #c9cdd4;
      background: #f7f8fa;
    }
  }
  .btn-confirm {
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    color: #fff;
    margin-left: 12px;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}
</style>
